export const reduceSumReport = (acc, item) => {
  const matchIndex = acc.findIndex(pItem => pItem.date === item.date)

  if (matchIndex > -1) {
    return [
      ...acc.slice(0, matchIndex),
      {
        date: item.date,
        amount: +item.amount + +acc[matchIndex].amount
      },
      ...acc.slice(matchIndex + 1)
    ]
  }

  return [
    ...acc,
    {
      date: item.date,
      amount: +item.amount
    }
  ]
}

export const reduceSumRevenue = (acc, item) => {
  const matchIndex = acc.findIndex(pItem => pItem.date === item.date)

  if (matchIndex > -1) {
    return [
      ...acc.slice(0, matchIndex),
      {
        date: item.date,
        total: +item.total + +acc[matchIndex].total,
        report: [...acc[matchIndex].report, ...item.report].reduce(
          reduceSumReport,
          []
        )
      },
      ...acc.slice(matchIndex + 1)
    ]
  }

  return [...acc, { ...item }]
}

export default {
  reduceSumRevenue
}



// WEBPACK FOOTER //
// ./src/utils/revenue/index.js